import { render, staticRenderFns } from "./VoucherGift.vue?vue&type=template&id=1d169629&scoped=true&"
import script from "./voucherGift.js?vue&type=script&lang=js&"
export * from "./voucherGift.js?vue&type=script&lang=js&"
import style0 from "./voucherGift.css?vue&type=style&index=0&id=1d169629&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d169629",
  null
  
)

export default component.exports